import { Typography } from "antd";
import { ReactComponent as PencilIcon } from "../../../../../common/images/svg/PencilSimpleLine.svg";
import { CustomButton } from "../../../../../components/button/buttonCustom";
import { ButtonOutlinedCustom } from "../../../../../components/button/buttonOulined";
import { useMetadataCurrency } from "../../../../../utils/hooks/useMetadataCurrency";
import { useMetadataCurrencyToken } from "../../../../../utils/hooks/useMetadataCurrencyToken";
import { useMetadataNetwork } from "../../../../../utils/hooks/useMetadataNetwork";
import { getLabelByValue } from "../../../../../utils/list.utils";
import {
  BankBeneficiary,
  InfoBeneficiary,
  WalletBeneficiary,
} from "../../../type";
import TextSubmit from "../text-submit";
import smartLogoDefault from "../../../../../common/images/svg/smart-logo-icon.svg";

interface IFormConfirmProps {
  onSubmit: () => void;
  onBack: () => void;
  stepNewBeneficiary: number | null;
  valueFormInfo: InfoBeneficiary | undefined;
  valueFormWallet: WalletBeneficiary | undefined;
  valueFormBank: BankBeneficiary | undefined;
  walletSkip: boolean;
  bankSkip: boolean;
  setStepNewBeneficiary: React.Dispatch<React.SetStateAction<number | null>>;
  loadingCreateCompany: boolean;
  bankSelected: any;
}

const FormConfirm = ({
  onSubmit,
  onBack,
  stepNewBeneficiary,
  valueFormInfo,
  valueFormWallet,
  valueFormBank,
  bankSelected,
  walletSkip,
  bankSkip,
  setStepNewBeneficiary,
  loadingCreateCompany,
}: IFormConfirmProps) => {
  const { metadataCurrency, dataCurrency } = useMetadataCurrency();
  const { metadataCurrencyToken, dataCurrencyToken } =
    useMetadataCurrencyToken();
  const { metadataNetwork } = useMetadataNetwork();

  const imageCurrencyToken = dataCurrencyToken.find(
    (item: any) => item.id === valueFormWallet?.currency
  ) as any;

  const imageCurrency = dataCurrency.find(
    (item: any) => item.code === valueFormBank?.currencyCode
  ) as any;

  return (
    <div style={{ display: stepNewBeneficiary === 4 ? "block" : "none" }}>
      <div className="form-submit-content">
        <div
          style={{ width: walletSkip && bankSkip ? "100%" : "50%" }}
          className="submit-info"
        >
          <div className="content-header">
            <Typography.Text className="header-title">
              Beneficiary
            </Typography.Text>
            <PencilIcon
              className="icon-animation"
              onClick={() => setStepNewBeneficiary(1)}
            />
          </div>
          <div className="content-body">
            <TextSubmit
              label="Company Name"
              value={valueFormInfo?.companyName || ""}
            />
            <TextSubmit
              label="Nick Name"
              value={valueFormInfo?.nickName || ""}
            />
            <TextSubmit
              label="Director's Name"
              value={`${valueFormInfo?.directorFirstName || ""} ${valueFormInfo?.directorLastName || ""
                }`}
            />
            <TextSubmit
              label="Address 1"
              value={valueFormInfo?.address1 || ""}
            />
            <TextSubmit
              label="Address 2"
              value={valueFormInfo?.address2 || ""}
            />
            <TextSubmit label="City" value={valueFormInfo?.city || ""} />
            <TextSubmit
              label="State/Province"
              value={valueFormInfo?.stateProvince || ""}
            />
            <TextSubmit
              label="Country of incorporation"
              value={valueFormInfo?.companyOfficiallyRegistered || ""}
            />
            <TextSubmit
              label="Postal Code"
              value={valueFormInfo?.postalCode || ""}
            />
            <TextSubmit label="TIN" value={valueFormInfo?.tinVatUid || ""} />
            <TextSubmit label="Reg No" value={valueFormInfo?.regNo || ""} />
            <TextSubmit label="Tel" value={valueFormInfo?.phoneNumber1 || ""} />
            <TextSubmit
              label="Contact Email"
              value={valueFormInfo?.email || ""}
            />
            <TextSubmit
              label="SMART UID"
              value={valueFormInfo?.smartUID || ""}
            />
            <TextSubmit label="Website" value={valueFormInfo?.website || ""} />
          </div>
        </div>
        <div
          style={{
            display: walletSkip && bankSkip ? "none" : "flex",
          }}
          className="submit-skip-info"
        >
          <div
            style={{ display: walletSkip ? "none" : "flex" }}
            className="submit-info"
          >
            <div className="content-header">
              <Typography.Text className="header-title">
                Wallet Address
              </Typography.Text>
              <PencilIcon
                className="icon-animation"
                onClick={() => setStepNewBeneficiary(2)}
              />
            </div>
            <div className="content-body">
              <TextSubmit label="Name" value={valueFormWallet?.name || ""} />
              <TextSubmit
                label="Currency"
                value={getLabelByValue(
                  metadataCurrencyToken,
                  valueFormWallet?.currency || ""
                )}
                icon={
                  imageCurrencyToken?.iconPath ? (
                    <img
                      alt="icon"
                      src={`${process.env.REACT_APP_ROOT_URL}/${imageCurrencyToken?.iconPath}`}
                      onError={(e) => {
                        e.currentTarget.src = smartLogoDefault;
                      }}
                      style={{ width: "28px", height: "28px" }}
                    />
                  ) : null
                }
              />
              <TextSubmit
                label="Network"
                value={getLabelByValue(
                  metadataNetwork,
                  valueFormWallet?.network || ""
                )}
              />
              <TextSubmit
                label="Address"
                value={valueFormWallet?.address || ""}
              />
            </div>
          </div>
          <div
            style={{ display: bankSkip ? "none" : "flex" }}
            className="submit-info"
          >
            <div className="content-header">
              <Typography.Text className="header-title">
                Bank Account
              </Typography.Text>
              <PencilIcon
                className="icon-animation"
                onClick={() => setStepNewBeneficiary(3)}
              />
            </div>
            <div className="content-body">
              <TextSubmit
                label="Bank Name"
                value={
                  bankSelected?.id
                    ? bankSelected.name
                    : valueFormBank?.bankName || ""
                }
              />
              <TextSubmit
                label="Bank Swift"
                value={
                  bankSelected?.id
                    ? bankSelected.swift
                    : valueFormBank?.bankSwift || ""
                }
              />
              <TextSubmit
                label="Bank Address"
                value={
                  bankSelected?.id
                    ? bankSelected.legalAddress
                    : `${valueFormBank?.bankAddress}, ${valueFormBank?.bankCountry}` ||
                    ""
                }
              />
              <TextSubmit
                label="Account No or IBAN"
                value={valueFormBank?.accountNumber || ""}
              />
              <TextSubmit
                label="Currency"
                value={getLabelByValue(
                  metadataCurrency,
                  valueFormBank?.currencyCode || ""
                )}
                icon={
                  imageCurrency?.iconPath ? (
                    <img
                      alt="icon"
                      src={`${process.env.REACT_APP_ROOT_URL}/${imageCurrency?.iconPath}`}
                      onError={(e) => {
                        e.currentTarget.src = smartLogoDefault;
                      }}
                      style={{ width: "28px", height: "28px" }}
                    />
                  ) : null
                }
              />
              <TextSubmit
                label="ABA Routing Number"
                value={valueFormBank?.abaRoutingNumber || ""}
              />
              <TextSubmit
                label="Bank State Branch Number"
                value={valueFormBank?.bankStateBranchNumber || ""}
              />
              <TextSubmit
                label="Branch Number"
                value={valueFormBank?.branchNumber || ""}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="form-submit-footer">
        <ButtonOutlinedCustom
          text={"Back"}
          size="large"
          width={136}
          onClick={onBack}
          isLoading={loadingCreateCompany}
        />
        <CustomButton
          text={"Submit"}
          size="large"
          onClick={onSubmit}
          isLoading={loadingCreateCompany}
        />
      </div>
    </div>
  );
};

export default FormConfirm;
